export const environment = {
  production: false,
  appVersion: require('../../package.json').version + '-dev',
  proxyURL: '',
  restURL: {
    baseUrl: 'https://apidev.xevira.id/',
    authUrl: 'https://apidev.xevira.id/',
    provision_key: 'QA2euZP3O214ZdYbXpmS0IOKfIPEZPy7',
    client_id: '0jubsFJCBOqq0aGpW30NEXB45s0jzes3',
    client_secret: '6btZKFb2u5tHIs1vheQbXqPlBRvJRDu8',
    grant_type: 'password'
  },
};
